import { render, staticRenderFns } from "./select_product.vue?vue&type=template&id=58fa94ed&scoped=true"
import script from "./select_product.vue?vue&type=script&lang=js"
export * from "./select_product.vue?vue&type=script&lang=js"
import style0 from "./select_product.vue?vue&type=style&index=0&id=58fa94ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fa94ed",
  null
  
)

export default component.exports